export default "/_next/static/chunks/fonts/GoudyOldStyleMT-2d59f36b73aa7727280f01b5a800f05a.ttf";